import { css, SerializedStyles } from '@emotion/core';
import { Theme, normalText, secondaryText } from 'features/Theme';

const style = {
  headingContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  body: (theme: Theme) => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  formFields: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  emphasizedText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    font-weight: bold;
    color: ${theme.mui.palette.text.primary};
  `,
  errorText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(1)}px;
    color: ${theme.mui.palette.error.main};
  `,
  textResend: (theme: Theme): SerializedStyles => css`
    ${secondaryText(theme)}
    font-weight: 600;
    color: ${theme.mui.palette.primary.main};
    text-decoration: underline;
  `,

  retryActions: (theme: Theme): SerializedStyles => css`
    ${secondaryText(theme)}
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  resetOr: (theme: Theme): SerializedStyles => css`
  ${secondaryText(theme)}
    margin-left: ${theme.mui.spacing(2)}px;
    margin-right: ${theme.mui.spacing(2)}px;
  `,
};

export default style;
